import { useQuery } from '@tanstack/react-query';
import { fetchFilterOptions, type FilterOptions } from '../services/conversations';
import { CONVERSATIONS_FILTERS_KEY } from './queryKeys';

const EMPTY: FilterOptions = { teams: [] };

export function useFilterOptions() {
    const { data, isLoading } = useQuery({
        queryKey: [CONVERSATIONS_FILTERS_KEY],
        queryFn: fetchFilterOptions,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true
    });

    return {
        filterOptions: data ?? EMPTY,
        isLoading
    };
}
